
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

const NavigationButtons = () => {
  return (
    <div className="fixed bottom-4 md:bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 md:gap-6 z-50 bg-white/80 backdrop-blur-sm px-3 py-3 md:px-6 md:py-3 rounded-full shadow-md">
      <Link to="/" className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 transition-colors duration-300">
        <Home size={14} className="md:w-4 md:h-4" />
      </Link>
      <Link to="/team" className="px-3 md:px-5 h-8 md:h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 transition-colors duration-300">
        <span className="text-xs font-medium">Team</span>
      </Link>
      <div className="px-3 md:px-5 h-8 md:h-10 flex items-center justify-center rounded-full bg-black/80 text-white">
        <span className="text-xs font-medium">Cosa facciamo</span>
      </div>
    </div>
  );
};

export default NavigationButtons;
